
const PromptTemplatesTab = ({
  promptTemplates,
  onUpdatePromptTemplate,
  onSavePromptTemplate
}) => {
  return (
    <div className="space-y-6">
      {/* Self Check Input Template */}
      <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-sm font-semibold text-gray-600">Input Check</h3>
          <button
            className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-secondary text-white rounded-lg hover:bg-secondaryDark"
            onClick={() => onSavePromptTemplate('self_check_input')}
          >
            Save Template
          </button>
        </div>

        <p className="text-gray-500 text-xs mb-3">
          This template is used to check if user input should be allowed or blocked based on content policies.
        </p>

        <textarea
          className="border border-gray-200 rounded w-full py-2 px-3 text-gray-700 focus:outline-none font-mono"
          rows={12}
          value={promptTemplates.self_check_input}
          onChange={(e) => onUpdatePromptTemplate('self_check_input', e.target.value)}
          placeholder="Enter self check input template..."
        />

        <p className="text-gray-400 text-xs mt-2">
          Use {'{{'} user_input {'}}'}  as a placeholder for the user's input.
        </p>
      </div>

      {/* Self Check Output Template */}
      <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-sm font-semibold text-gray-600">Output Check</h3>
          <button
            className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-secondary text-white rounded-lg hover:bg-secondaryDark"
            onClick={() => onSavePromptTemplate('self_check_output')}
          >
            Save Template
          </button>
        </div>

        <p className="text-gray-500 text-xs mb-3">
          This template is used to check if the bot's response meets moderation policies.
        </p>

        <textarea
          className="border border-gray-200 rounded w-full py-2 px-3 text-gray-700 focus:outline-none font-mono"
          rows={12}
          value={promptTemplates.self_check_output}
          onChange={(e) => onUpdatePromptTemplate('self_check_output', e.target.value)}
          placeholder="Enter self check output template..."
        />

        <p className="text-gray-400 text-xs mt-2">
          Use {'{{'} user_input {'}}'}  and {'{{'} bot_response {'}}'}  as placeholders.
        </p>
      </div>

      {/* Self Check Hallucination Template */}
      <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-sm font-semibold text-gray-600">Hallucination Check</h3>
          <button
            className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-secondary text-white rounded-lg hover:bg-secondaryDark"
            onClick={() => onSavePromptTemplate('self_check_hallucination')}
          >
            Save Template
          </button>
        </div>

        <p className="text-gray-500 text-xs mb-3">
          This template is used to check if the bot's response contains factual information supported by context.
        </p>

        <textarea
          className="border border-gray-200 rounded w-full py-2 px-3 text-gray-700 focus:outline-none font-mono"
          rows={12}
          value={promptTemplates.self_check_hallucination}
          onChange={(e) => onUpdatePromptTemplate('self_check_hallucination', e.target.value)}
          placeholder="Enter self check hallucination template..."
        />

        <p className="text-gray-400 text-xs mt-2">
          Use {'{{'} paragraph {'}}'}  and {'{{'} statement {'}}'}  as placeholders.
        </p>
      </div>
    </div>
  );
};

export default PromptTemplatesTab;
